// Rollenwahl ohne Berechtigungssystem (PERMISSION_SYSTEM), rein und ohne
// React. Gesperrt heißt enforced und das Feature fehlt im Paket, das liefert
// useFeatureGate. Dann ist nur Admin frei wählbar und neue Teammitglieder
// bekommen Admin. Beim Bearbeiten bleibt die bestehende Rolle stehen und
// wählbar, ein Wechsel zu Admin geht immer. In legacy und preview ist nichts
// gesperrt, die Rollenwahl bleibt wie bisher.
import { ROLES } from '../../../helpers/authorization-roles'

export const PERMISSION_FEATURE = 'PERMISSION_SYSTEM'

// Ein Wechsel zu Admin ist nie gesperrt
export const FREE_ROLE_ID = ROLES.ADMIN.id

/**
 * Gesperrte Rollen-IDs für die Auswahl.
 *
 * @param {{ locked: boolean, currentRoleId?: string|null }} params
 *   currentRoleId ist die gespeicherte Rolle beim Bearbeiten
 * @returns {string[]}
 */
export const lockedRoleIds = ({ locked, currentRoleId = null }) => {
  if (!locked) return []

  return Object.keys(ROLES).filter(
    (id) => id !== FREE_ROLE_ID && id !== currentRoleId
  )
}

/**
 * Rolle, die angezeigt und gespeichert wird. Ist die gewählte gesperrt, etwa
 * der Default Manager oder eine Wahl von vor dem Laden der Entitlements, gilt
 * fallbackId und danach Admin. Ohne Sperre bleibt die Wahl unverändert.
 *
 * @param {{ roles: Array<{ id: string }>, selected: { id: string },
 *   lockedIds: string[], fallbackId?: string }} params
 */
export const resolveSelectedRole = ({
  roles,
  selected,
  lockedIds,
  fallbackId = FREE_ROLE_ID
}) => {
  if (!selected || !lockedIds.includes(selected.id)) return selected

  return (
    roles.find(({ id }) => id === fallbackId && !lockedIds.includes(id)) ||
    roles.find(({ id }) => id === FREE_ROLE_ID) ||
    selected
  )
}
